import { ButtonPropsWithLabel } from 'src/components/Dialog';
import { Stack } from 'src/components/Stack';

import { ActionsList } from './ActionsList';
import { BlockingReasonList } from './BlockingReasonList';
import { BookingSessionDetails } from './BookingSessionDetails';
import { CheckinBlockerSessionDetails, CheckinBlockerUser } from './_types';

export function SessionContent({
  users,
  actions,
  getBlockerActions,
  sessionDetails,
}: {
  users: CheckinBlockerUser[];
  actions?: ButtonPropsWithLabel[];
  getBlockerActions?: (
    user: CheckinBlockerUser,
    blocker: CheckinBlockerUser['blockers'][number]
  ) => ButtonPropsWithLabel[] | undefined;
  sessionDetails: CheckinBlockerSessionDetails;
}) {
  return (
    <Stack spacing={3} sx={{ width: '100%' }}>
      {users.map((user, index) => (
        <Stack
          key={
            user.id != null && user.id !== ''
              ? user.id
              : `checkin-blocker-${index}`
          }
          spacing={2}
          sx={{ width: '100%' }}
        >
          <BlockingReasonList
            blockers={user.blockers}
            getBlockerActions={(blocker) => getBlockerActions?.(user, blocker)}
            userId={user.id ?? ''}
            variant="booking"
          />
        </Stack>
      ))}

      <BookingSessionDetails sessionDetails={sessionDetails} />

      {!!actions && <ActionsList actions={actions} />}
    </Stack>
  );
}
